/* eslint-disable no-var */
import { closeEhrViewer } from "./ehrViewer";

export const TOKEN_KEY = "assets-token-web";

export function isImage(type: string) {
  if (!type) {
    return false;
  }
  let flag = false;
  try {
    flag = ["png", "jpeg", "gif", "bmp", "svg", "webp", "jpg"].includes(type.toLowerCase());
  } catch (error) {
    console.log(error);
  }
  return flag
}
export function getToken() {
  const token = window.localStorage.getItem(TOKEN_KEY);
  if (token) {
    window.sessionStorage.setItem(TOKEN_KEY, token);
  }
  return token;
}

export function setToken(token: string) {
  window.localStorage.setItem(TOKEN_KEY, token);
  window.sessionStorage.setItem(TOKEN_KEY, token);
}

export function setTempToken(token: string) {
  window.localStorage.setItem(TOKEN_KEY, token);
  window.sessionStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  setToken("");
  setTempToken("");
  // eHealth IN025: logging out of the EMR closes the eHR Viewer window. Both logout paths
  // (avatar menu in layout/header.vue and the 401 auto-logout in utils/request.ts) end here.
  closeEhrViewer();
}

export function splitArray(array: any[], parts: number) {
  const result = [];
  const length = array.length;
  const chunkSize = Math.ceil(length / parts);

  for (let i = 0; i < length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }

  return result;
}

export function handleBinarization(url: string) {
  const canvas = document.createElement('canvas')
  const img = new Image()
  img.src = url;
  img.onload = () => {
    const { width, height } = img;
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d')
    if (ctx) {
      ctx.drawImage(img, 0, 0, width, height)
      let imageData = ctx.getImageData(0, 0, width, height)


      imageData = binarization(imageData)
      ctx.putImageData(imageData, 0, 0);


      const result = canvas.toDataURL()
      const newImg = document.createElement('img');
      newImg.style.width = '100%'
      newImg.style.position = 'absolute'
      newImg.style.top = '0'
      newImg.style.left = '0'
      newImg.style.zIndex = '999'
      newImg.src = result;
      document.body.appendChild(newImg);
    }
  }


}

/**
 * 图片二值化处理
 * @param imgData 
 * @returns 
 */
function binarization(imgData: any) {
  var index = 255 / 2; //阈值
  for (var i = 0; i < imgData.data.length; i += 4) {
    var R = imgData.data[i];
    var G = imgData.data[i + 1];
    var B = imgData.data[i + 2];
    var sum = (R + G + B) / 3;
    if (sum > index) {
      imgData.data[i] = 255;
      imgData.data[i + 1] = 255;
      imgData.data[i + 2] = 255;
    } else {
      imgData.data[i] = 0;
      imgData.data[i + 1] = 0;
      imgData.data[i + 2] = 0;
    }
  }
  return imgData;
}

export function handleBBcolor(url: string) {
  const canvas = document.createElement('canvas')
  const img = new Image()
  img.src = url;
  img.onload = () => {
    const { width, height } = img;
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d')
    if (ctx) {
      ctx.drawImage(img, 0, 0, width, height)
      let imageData = ctx.getImageData(0, 0, width, height)
      imageData = BBcolor(imageData, 5, 6, 6, 3)
      ctx.putImageData(imageData, 0, 0);
      const result = canvas.toDataURL()

      const newImg = document.createElement('img');
      newImg.style.width = '100%'
      newImg.style.position = 'absolute'
      newImg.style.top = '0'
      newImg.style.left = '0'
      newImg.style.zIndex = '999'
      newImg.src = result;
      document.body.appendChild(newImg);
      console.log("图片数据", newImg);
    }
  }


}


/**
  * 双边滤波
*/
function BBcolor(imgData: any, radius: number, sigma: number, sigma_color: number, channels: number) {
  var pixes = imgData.data,
    width = imgData.width,
    height = imgData.height,
    color_weight = [],
    channels = channels || 3,
    sigma_color = sigma_color || (radius / 3),
    coeff_color = -1 / (2 * sigma_color * sigma_color),
    radius = radius || 5;

  sigma = sigma || (radius / 3);


  var gaussEdge = radius * 2 + 1; // 高斯矩阵的边长
  for (var i = 0; i < channels * 256; i++) {
    color_weight[i] = Math.exp(i * i * coeff_color);
  }
  var gaussMatrix = [],
    a = 1 / (2 * sigma * sigma * Math.PI),
    b = -a * Math.PI;

  for (var i = -radius; i <= radius; i++) {
    for (var j = -radius; j <= radius; j++) {
      var gxy = a * Math.exp((i * i + j * j) * b);
      gaussMatrix.push(gxy);
      // gaussSum += gxy; // 得到高斯矩阵的和，用来归一化
    }
  }

  // 循环计算整个图像每个像素高斯处理之后的值
  for (var x = 0; x < width; x++) {
    for (var y = 0; y < height; y++) {
      var r = 0,
        g = 0,
        b = 0,
        wsum = 0,
        currentPixId0 = (y * width + x) * 4,
        r0 = pixes[currentPixId0],
        g0 = pixes[currentPixId0 + 1],
        b0 = pixes[currentPixId0 + 2];
      // 计算每个点的高斯处理之后的值
      for (var i = -radius; i <= radius; i++) {
        // 处理边缘
        var m = handleEdge(i, x, width);
        for (var j = -radius; j <= radius; j++) {
          // 处理边缘
          var mm = handleEdge(j, y, height);

          var currentPixId = (mm * width + m) * 4;

          var jj = j + radius,
            ii = i + radius,
            r1 = pixes[currentPixId],
            g1 = pixes[currentPixId + 1],
            b1 = pixes[currentPixId + 2];

          var weight = gaussMatrix[jj * gaussEdge + ii] * color_weight[Math.abs(r1 - r0) + Math.abs(g1 - g0) + Math.abs(b1 - b0)];
          r += pixes[currentPixId] * weight;
          g += pixes[currentPixId + 1] * weight;
          b += pixes[currentPixId + 2] * weight;
          wsum += weight;
        }
      }
      wsum = 1 / wsum;
      var pixId = (y * width + x) * 4;
      pixes[pixId] = ~~(wsum * r);
      pixes[pixId + 1] = ~~(wsum * g);
      pixes[pixId + 2] = ~~(wsum * b);
    }
  }
  // imgData.data = pixes;
  return imgData;
}

function handleEdge(i: number, x: number, w: number) {
  var m = x + i;
  if (m < 0) {
    m = -m;
  } else if (m >= w) {
    m = w + i - x;
  }
  return m;
}


export const DownloadFile = (blob: Blob, filename: string) => {
  const downloadElement = document.createElement('a');
  const href = window.URL.createObjectURL(blob);
  downloadElement.style.display = 'none';
  downloadElement.href = href;
  downloadElement.download = filename;
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
  window.URL.revokeObjectURL(href);
};

/**
 * 浮点数加法计算
 */
export function addition(num1: number, num2: number) {
  if (num1 === 0) {
    return num2;
  }
  if (num2 === 0) {
    return num1;
  }
  if (!num1) num1 = 0; if (!num2) num1 = 0;

  const n1: any = num1.toString(), n2: any = num2.toString();
  let place = 0;
  const n1Arr: any = n1.split('.');
  const n2Arr: any = n2.split('.');
  if (n1Arr.length > 1) {
    place = n1Arr[1].length;
  }
  if (n2Arr.length > 1 && n2Arr[1].length > place) {
    place = n2Arr[1].length;
  }
  let v1 = 0, v2 = 0;
  if (n1Arr[1]) {
    n1Arr[1] = n1Arr[1].padEnd(place, 0);
    v1 = parseInt(n1Arr.join(''));
  } else {
    n1Arr[0] = n1Arr[0].padEnd(n1Arr[0].length + place, 0);
    v1 = parseInt(n1Arr[0]);
  }

  if (n2Arr[1]) {
    n2Arr[1] = n2Arr[1].padEnd(place, 0);
    v2 = parseInt(n2Arr.join(''));
  } else {
    n2Arr[0] = n2Arr[0].padEnd(n2Arr[0].length + place, 0);
    v2 = parseInt(n2Arr[0]);
  }

  let value: any = v1 + v2;
  value = value.toString();
  const result = value.slice(0, value.length - place) + '.' + value.slice(value.length - place);
  return parseFloat(result);
}

/**
 * Append query params to a URL, choosing "?" or "&" correctly.
 * Legacy attachment URLs (/oss-ali/v/<hash>) carry no query string at all, so blindly
 * appending "&download=true" produced a garbage OSS key and a 404 NoSuchKey.
 *
 * Keys the url already carries are skipped. Without that guard
 * `previewFile(signedViewUrl(f))` emitted `access-token` twice — both helpers add it — which
 * duplicates the session token in every url that reaches a log or a browser history entry.
 */
export function withQuery(url: string, params: Record<string, string | number | boolean | undefined | null>) {
  if (!url) return "";
  const existing = new Set(
    (url.split("?")[1] || "").split("&").map((p) => decodeURIComponent(p.split("=")[0])).filter(Boolean)
  );
  const qs = Object.entries(params)
    .filter(([k, v]) => v !== undefined && v !== null && v !== "" && !existing.has(k))
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join("&");
  if (!qs) return url;
  return url + (url.includes("?") ? "&" : "?") + qs;
}

/**
 * Our own attachment proxy. The access-token may ONLY be attached to this endpoint —
 * legacy files are served by a retired third-party host and must never receive it.
 */
export function isOwnPreviewUrl(url: string) {
  return !!url && /(^|\/)oss\/file\/preview(\?|$)/.test(url);
}

export function imageUrlAndToken (url:any) {
  if (!url) return "";
  return isOwnPreviewUrl(url) ? withQuery(url, { "access-token": getToken() }) : url;
}

export function previewFile (url:string) {
  if (!url) return;
  const currentUrl = isOwnPreviewUrl(url) ? withQuery(url, { "access-token": getToken() }) : url;
  window.open(currentUrl, "_blank");
}

export function depthPath (source:any, map:Set<string>, arr:any[] = [] ) {
  for (const key in source) {
    if (key === 'x' || key === 'y') {
      break;
    }
    arr.push(key);
    if (typeof source[key] === 'object' ) {
      depthPath(source[key], map, arr);
    }
    map.add(arr.join('.'))
    arr.pop();
  }
}

